import React from "react";
import "../CSS/Skills.css";

export const Skills=()=>{
    return(
        <>
            <div className="Skillcontainer">
                <h1 className="Skillhead">Skills</h1>
                <div >
                    <h1 className="ux">User Experience (UX) Design</h1>
                    <div className="userexperience">
                    <Skillcard skill={"Design Audit"}/>
                    <Skillcard skill={"Usability Testing"}/>
                    <Skillcard skill={"UX Research"}/>
                    <Skillcard skill={"Wire framing"}/>
                    <Skillcard skill={"User Journey"}/>
                    </div>
                    
                </div>

                <div >
                    <h1 className="ui">User Interface (UI) Design</h1>
                    <div className="userinterface">
                    <Skillcard skill={"User Interface"}/>
                    <Skillcard skill={"Micro Interactions"}/>
                    <Skillcard skill={"Digital prototyping"}/>
                    <Skillcard skill={"Web Platform"}/>
                    <Skillcard skill={"Iconograpghy"}/>
                    <Skillcard skill={"Mobile Application"}/>
                    <Skillcard skill={"Illutration"}/>
                    </div>
                    
                </div>

                <div >
                    <h1 className="brand">Branding Design</h1>
                    <div className="branding">
                    <Skillcard skill={"Logo Design"}/>
                    <Skillcard skill={"Social Media Design"}/>
                    <Skillcard skill={"Branding Design"}/>
                    </div>
                </div>
            </div>
        </>
    )
}

const Skillcard=({skill})=>{
    return(
        <>
            <div className="smallcard">{skill}</div>
        </>
    )
}